/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InsuranceClaimItem from './insurance-claim-item';
import InsuranceClaimItemDetail from './insurance-claim-item-detail';
import InsuranceClaimItemUpdate from './insurance-claim-item-update';
import InsuranceClaimItemDeleteDialog from './insurance-claim-item-delete-dialog';

const InsuranceClaimItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InsuranceClaimItem />} />
    <Route path="new" element={<InsuranceClaimItemUpdate />} />
    <Route path=":id">
      <Route index element={<InsuranceClaimItemDetail />} />
      <Route path="edit" element={<InsuranceClaimItemUpdate />} />
      <Route path="delete" element={<InsuranceClaimItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InsuranceClaimItemRoutes;
